if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      waitForBootstrap(loadCarouselComponentEventListeners);
    });
  } else {
    waitForBootstrap(loadCarouselComponentEventListeners);
  }
}

function waitForBootstrap(callback) {
  if (window.bootstrap) {
    callback();
  } else {
    let attempts = 0;
    const maxAttempts = 50; // 5 seconds max
    const intervalId = setInterval(() => {
      attempts++;
      if (window.bootstrap) {
        clearInterval(intervalId);
        callback();
      } else if (attempts >= maxAttempts) {
        clearInterval(intervalId);
      }
    }, 100);
  }
}

function loadCarouselComponentEventListeners() {
  document.querySelectorAll('.carousel').forEach((carouselContainer) => {
    let playPauseBtn = carouselContainer.querySelector('.mhe-play-pause-carousel-btn');
    let prevBtn = carouselContainer.querySelector('.carousel-control-prev');
    let nextBtn = carouselContainer.querySelector('.carousel-control-next');
    let dots = carouselContainer.querySelectorAll('.carousel-dots');
    let carouselInner = carouselContainer.querySelector('.carousel-inner');
    let carouselIndicators = carouselContainer.querySelector('.carousel-indicators');
    const CAROUSEL_FOCUSABLE_SELECTORS =
      '.carousel-item button:not([disabled]), .carousel-item a[href], .carousel-item input:not([disabled]), .carousel-item select:not([disabled]), .carousel-item [tabindex]:not([tabindex="-1"])';
    // eslint-disable-next-line no-undef
    let carousel = new window.bootstrap.Carousel(carouselContainer, { pause: false });
    // Keep the custom state aligned with Bootstrap's authored autoplay configuration.
    let carouselPaused =
      carouselContainer.dataset.bsRide !== 'carousel' || carouselContainer.dataset.bsInterval === 'false';
    const updateCarouselLiveState = () => {
      carouselInner?.setAttribute('aria-live', carouselPaused ? 'polite' : 'off');
    };
    updateCarouselLiveState();

    // Respect prefers-reduced-motion: do not autoplay if user preference is set
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reducedMotion.matches && playPauseBtn) {
      carousel.pause();
      carouselPaused = true;
      updateCarouselLiveState();
      playPauseBtn.setAttribute('aria-label', 'Start Automatic Slide Show');
      playPauseBtn.querySelector('uxt-icon')?.setAttribute('icon', 'play');
    }

    // Listen for dynamic changes to the motion preference
    reducedMotion.addEventListener('change', (e) => {
      if (e.matches && !carouselPaused && playPauseBtn) {
        carousel.pause();
        carouselPaused = true;
        updateCarouselLiveState();
        playPauseBtn.setAttribute('aria-label', 'Start Automatic Slide Show');
        playPauseBtn.querySelector('uxt-icon')?.setAttribute('icon', 'play');
      }
    });

    function updateCarouselAttributes() {
      if (!dots.length) return;
      dots.forEach((dot) => {
        if (dot.classList.contains('active')) {
          dot.removeAttribute('tabindex');
          dot.setAttribute('aria-selected', 'true');
        } else {
          dot.setAttribute('tabindex', '-1');
          dot.setAttribute('aria-selected', 'false');
        }
        dot.removeAttribute('aria-current');
      });
    }

    // Play/Pause button behavior
    let clickListener = function () {
      if (carousel && playPauseBtn) {
        if (carouselPaused) {
          carousel.cycle();
          carouselPaused = false;
          //set aria-live to off since slide changes events in auto-play mode should not be announced by SR.
          updateCarouselLiveState();
          playPauseBtn.setAttribute('aria-label', 'Pause Automatic Slide Show');
          playPauseBtn.querySelector('uxt-icon').setAttribute('icon', 'pause');
        } else {
          carousel.pause();
          carouselPaused = true;
          updateCarouselLiveState();
          playPauseBtn.setAttribute('aria-label', 'Start Automatic Slide Show');
          playPauseBtn.querySelector('uxt-icon').setAttribute('icon', 'play');
        }
      }
    };
    playPauseBtn?.addEventListener('click', clickListener);

    // Focus management for control buttons
    let focusList = [];
    if (playPauseBtn) focusList.push(playPauseBtn);
    if (prevBtn) focusList.push(prevBtn);
    if (nextBtn) focusList.push(nextBtn);
    dots?.forEach((dot) => {
      focusList.push(dot);
    });
    // Add focusable elements within slides to the focus list to pause the carousel when they receive focus
    carouselInner?.querySelectorAll(CAROUSEL_FOCUSABLE_SELECTORS).forEach((focusable) => {
      if (!focusList.includes(focusable)) {
        focusList.push(focusable);
      }
    });
    focusList.forEach((element) => {
      element.addEventListener('focus', (e) => {
        carousel.pause();
        carouselPaused = true;
        updateCarouselLiveState();
        if (e.target.classList.contains('mhe-play-pause-carousel-btn')) {
          // Focus alone must not resume playback; activation is handled by clickListener.
        }
      });
      element.addEventListener('blur', (e) => {
        let focusOutsideCarousel = !carouselContainer.contains(e.relatedTarget);
        if (focusOutsideCarousel) {
          updateCarouselLiveState();
        }
      });
    });

    carouselContainer.addEventListener('focusout', (e) => {
      if (!carouselContainer.contains(e.relatedTarget)) {
        updateCarouselLiveState();
      }
    });

    // Manual navigation keeps the live region polite while rotation is stopped.
    let onClickCarouselNavigation = function () {
      carousel.pause();
      carouselPaused = true;
      carouselInner?.setAttribute('aria-live', 'polite');
    };

    // Focus management for dots
    dots?.forEach((dot, index) => {
      // Handle Arrow key navigation
      dot.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          let newIndex = e.key === 'ArrowRight' ? index + 1 : index - 1;
          if (newIndex >= dots.length) newIndex = 0; // Wrap around to the first dot
          if (newIndex < 0) newIndex = dots.length - 1; // Wrap around to the last dot
          dots[newIndex].focus(); // Move focus to the new active dot
          dots[newIndex].click(); // Trigger the slide change
        }
      });
      dot.addEventListener('click', onClickCarouselNavigation);
    });

    prevBtn?.addEventListener('click', onClickCarouselNavigation);
    nextBtn?.addEventListener('click', onClickCarouselNavigation);

    function updateCarouselSlideRoles(carouselInner, carouselIndicators) {
      let indicatorsVisible = carouselIndicators?.checkVisibility();
      let slideRole = indicatorsVisible ? 'tabpanel' : 'group';
      carouselInner?.querySelectorAll('.carousel-item').forEach((item) => {
        item.setAttribute('role', slideRole);
      });
    }
    updateCarouselSlideRoles(carouselInner, carouselIndicators);

    // Update attributes on slide change
    carouselContainer.addEventListener('slid.bs.carousel', () => {
      updateCarouselAttributes();
      if (carouselPaused) {
        carousel.pause();
      }
    });

    // Initialize attributes on load
    updateCarouselAttributes();
  });
}
